
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tasks",
      function () {
        return require("private-next-pages/tasks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tasks"])
      });
    }
  